import React from "react";
import { Route, Routes } from "react-router-dom";
import { appRoutesConfig } from "./appRouteConfig";

/**
 * Render React Router `<Route>` nodes from a centralized config array.
 * This keeps `src/App.js` focused on providers/layout, not routing details.
 */
function renderRouteNodes(routes) {
  return routes.map((r, idx) => {
    const key = `${r.path ?? "index"}-${r.index ? "index" : "path"}-${idx}`;

    const routeProps = {
      key,
      element: r.element,
    };

    if (r.index) {
      routeProps.index = true;
    } else {
      routeProps.path = r.path;
    }

    if (r.children && r.children.length > 0) {
      return (
        <Route
          {...routeProps}
        >
          {renderRouteNodes(r.children)}
        </Route>
      );
    }

    return <Route {...routeProps} />;
  });
}

export default function AppRoutes() {
  return <Routes>{renderRouteNodes(appRoutesConfig)}</Routes>;
}

